export default "__VITE_ASSET__DSPvDfmj__"